<template>
  <div class="layout">
    <Layout>
      <Header>
        <Navbar/>
      </Header>
      <Layout>
        <Layout :style="{padding: '0 44px 24px'}">
          <img src="../assets/banner.jpeg">
          <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
            <Category/>
            <h2>Trending</h2>
            <Trending tag="spanish" />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue"
import Category from "@/components/Category.vue"
import Trending from "@/components/Trending.vue"
export default {
  name: "Home",
  components: {
    Navbar,
    Category,
    Trending
  },
  created() {
  }
}
</script>
<style>
.ivu-layout-header {
  background:#2a2b2d !important;
}
</style>
